import { createSlice } from '@reduxjs/toolkit';

import { City } from 'entities/City';
import { State } from 'entities/State';
import { AppError } from 'entities/Errors';

import { getStateList, getStateCityList } from './state.action';

interface StateState {
  loading: boolean;
  error: AppError | null;
  states: State[];
  stateCities: City[];
}

const initialState = {
  loading: false,
  error: null,
  states: [],
  stateCities: [],
} as StateState;

export const stateSlice = createSlice({
  name: 'state',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getStateList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getStateList.fulfilled, (state, action) => {
        state.loading = false;
        state.states = action.payload.data;
      })
      .addCase(getStateList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as AppError;
      });

    builder
      .addCase(getStateCityList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getStateCityList.fulfilled, (state, action) => {
        state.loading = false;
        state.stateCities = action.payload.data;
      })
      .addCase(getStateCityList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as AppError;
      });
  },
});

export default stateSlice.reducer;
